'use es6';

import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { fromJS, List } from 'immutable';
import indexBy from 'transmute/indexBy';
import get from 'transmute/get';
const formatEmailCampaignUrlRecord = url => {
  return new ReferenceRecord({
    id: url.url,
    label: url.url,
    referencedObject: fromJS(url)
  });
};
const formatEmailCampaignUrls = response => {
  const results = indexBy(get('id'), List(response).map(formatEmailCampaignUrlRecord));
  return {
    count: results.size,
    offset: 0,
    hasMore: false,
    results
  };
};
export default formatEmailCampaignUrls;